<header class="top-bar" (click)="$event.stopPropagation()">
  <div class="top-bar__inner">
    <a
      class="top-bar__brand"
      href="https://www.rackspace.com"
      aria-label="Rackspace Technology">
      <img
        src="/assets/rax.png"
        alt="Rackspace Technology"
        width="128"
        height="32"
        class="top-bar__logo"
      />
    </a>

    <div class="top-bar__actions top-bar__actions--desktop">
      <a [href]="phoneHref" class="top-bar__phone">
        <svg class="top-bar__phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.516l.57 2.292a2 2 0 01-.45 1.79l-1.2 1.2a16 16 0 006.586 6.586l1.2-1.2a2 2 0 011.79-.45l2.292.57A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C9.163 21 3 14.837 3 7V5z"
          />
        </svg>
        <span class="top-bar__phone-text">
          {{ textService.getText('pocket_phone_sales') }}: {{ phone }}
        </span>
      </a>

      <div class="top-bar__dropdown">
        <button
          type="button"
          class="top-bar__btn"
          [class.is-open]="isLoginOpen"
          (click)="toggleLogin($event)"
          [attr.aria-expanded]="isLoginOpen">
          <svg class="top-bar__btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span>{{ textService.getText('log_in') }}</span>
          <svg class="top-bar__btn-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div class="top-bar__menu" *ngIf="isLoginOpen">
          <a
            *ngFor="let link of loginLinks"
            class="top-bar__menu-link"
            [href]="link.href"
            target="_blank"
            rel="noopener noreferrer">
            {{ link.label }}
          </a>
        </div>
      </div>

      <app-language-translation></app-language-translation>
    </div>

    <button
      type="button"
      class="top-bar__toggle"
      (click)="toggleMenu()"
      [attr.aria-expanded]="isMenuOpen"
      aria-label="Toggle navigation menu">
      <svg *ngIf="!isMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
      <svg *ngIf="isMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div class="top-bar__mobile" *ngIf="isMenuOpen">
    <a [href]="phoneHref" class="top-bar__phone top-bar__phone--mobile">
      <svg class="top-bar__phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.516l.57 2.292a2 2 0 01-.45 1.79l-1.2 1.2a16 16 0 006.586 6.586l1.2-1.2a2 2 0 011.79-.45l2.292.57A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C9.163 21 3 14.837 3 7V5z"
        />
      </svg>
      <span class="top-bar__phone-text">
        {{ textService.getText('pocket_phone_sales') }}: {{ phone }}
      </span>
    </a>

    <div class="top-bar__mobile-section">
      <p class="top-bar__mobile-heading">{{ textService.getText('log_in') }}</p>
      <a
        *ngFor="let link of loginLinks"
        class="top-bar__mobile-link"
        [href]="link.href"
        target="_blank"
        rel="noopener noreferrer">
        {{ link.label }}
      </a>
    </div>

    <div class="top-bar__mobile-lang">
      <app-language-translation></app-language-translation>
    </div>
  </div>
</header>
